import { useEffect, useState } from 'react'

export const SPARTACUS_MOBILE_MAX_WIDTH = 767

function getIsSpartacusMobileViewport() {
  if (typeof window === 'undefined') {
    return false
  }

  return window.innerWidth <= SPARTACUS_MOBILE_MAX_WIDTH
}

export function useSpartacusMobile() {
  const [isMobile, setIsMobile] = useState(() => getIsSpartacusMobileViewport())

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsSpartacusMobileViewport())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}

export { getIsSpartacusMobileViewport }
